/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

export default [
  {
    width: 180,
    label: '姓名',
    tip: '请输入姓名',
    maxLength: 50,
    key: 'fullName',
    id: 'fullName',
    slot: 'input'
  },
  {
    width: 180,
    label: '手机号',
    tip: '请输入手机号',
    maxLength: 50,
    key: 'phone',
    id: 'phone',
    slot: 'input'
  },
  {
    width: 200,
    label: '项目名称/项目编码',
    tip: '请输入项目名称/项目编码',
    key: 'projectName',
    id: 'projectName',
    slot: 'input'
  },
  {
    width: 180,
    label: '授权状态',
    tip: '请选择授权状态',
    key: 'authStatus',
    id: 'authStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '未授权',
        key: 0
      },
      {
        name: '已授权',
        key: 1
      }
    ]
  },
  {
    width: 200,
    label: '是否存在报税关系',
    tip: '请选择是否存在报税关系',
    key: 'isEmploy',
    id: 'isEmploy',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '是',
        key: 1
      },
      {
        name: '否',
        key: 0
      }
    ]
  },
  {
    id: 'dealTime',
    width: 180,
    tip: '执行发生时间',
    label: '更新日期',
    slot: 'daterange',
    type: 'daterange',
    key: ['startAuthDt', 'endAuthDt'],
    text: ['起始日期', '结束日期']
  },
  {
    width: 180,
    tip: '是否可结算',
    label: '是否可结算',
    tip: '请选择是否可结算',
    key: 'isSettlement',
    id: 'isSettlement',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '可结算',
        key: 1
      },
      {
        name: '不可结算',
        key: 0
      }
    ]
  }
];
